import(/* webpackMode: "eager" */ "/builds/wartek-id/data-pipeline/data-portal-ui/modules/DataInduk/yayasan/DataIndukYayasan.tsx")